<span class="player__close">
    <a class="button button-transparent p-0 w-42 h-42" href="#">{{ svg "x" 44 "icon"}}</a>
</span>
